import { z } from 'zod';
import { JSON_RPC_VERSION, MAX_JSON_RPC_BATCH_SIZE } from '../constants/json-rpc.js';
export const rpcIdSchema = z.union([z.string(), z.number(), z.null()]);
export const rpcRequestSchema = z.object({
    method: z.string().min(1),
    params: z.array(z.unknown()).optional(),
    id: z.union([z.string(), z.number()]).optional(),
}).strict();
export const rpcBatchRequestSchema = z
    .array(rpcRequestSchema)
    .min(1)
    .max(MAX_JSON_RPC_BATCH_SIZE, `Maximum ${MAX_JSON_RPC_BATCH_SIZE} RPC requests per batch`);
export const rpcSuccessResponseSchema = z.object({
    jsonrpc: z.literal(JSON_RPC_VERSION),
    result: z.unknown(),
    id: rpcIdSchema,
}).strict();
export const rpcErrorResponseSchema = z.object({
    jsonrpc: z.literal(JSON_RPC_VERSION),
    error: z.object({
        code: z.number().int(),
        message: z.string().min(1),
        data: z.unknown().optional(),
    }).strict(),
    id: rpcIdSchema,
}).strict();
export const rpcResponseSchema = z.union([rpcSuccessResponseSchema, rpcErrorResponseSchema]);
export const rpcBatchResponseSchema = z.array(rpcResponseSchema);
